import * as _ from 'lodash';

let langPack: any;

export function setLangPack(lp) {
  langPack = lp;
}

export function getTextOfKeyInCurrentLang(key: string): string {
  return _.get(langPack, key, '');
}

export const L: (key: string) => string = getTextOfKeyInCurrentLang;
if (process.env.BROWSER) {
  // window.L = L;
}
